import React, { useEffect, useState, useRef, useContext } from "react";
import { connect } from "react-redux";
import { setBreadcrumbItems } from "../../store/actions";
import axios from "../../utils/axios";
import Swal from 'sweetalert2';
import { Link } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { motion, AnimatePresence } from 'framer-motion';
import { Video, Image, X, Loader, Check } from 'react-feather';
import Select from 'react-select';
import ReactCrop from 'react-image-crop';
import { FiMoreVertical, FiEdit2, FiTrash2, FiEye } from 'react-icons/fi';
import 'react-image-crop/dist/ReactCrop.css';
import { useNavigate } from 'react-router-dom';
import { Upload as TusUpload } from 'tus-js-client';
import { UserContext } from "context/userContext";
import {
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Form,
    FormGroup,
    Label,
    InputGroup,
    Badge,
    Input,
    Button,
    Progress
} from 'reactstrap';
import moment from 'moment';
import PlayIcon from '../../assets/images/play.png'

const CoursesManagement = (props) => {

    document.title = "Courses Management | Equity Circle - Admin Dashboard";
    const breadcrumbItems = [
        { title: "Courses Management", link: "#" },
        { title: "All Courses", link: "#" },
    ];
    const [menuOpen, setMenuOpen] = useState(false);
    const navigate = useNavigate();
    // State for modal and form
    const { userData } = useContext(UserContext);
    const [showCategoryModal, setShowCategoryModal] = useState(false);
    const [newCategory, setNewCategory] = useState({ name: '', tags: '' });
    const [isEditMode, setIsEditMode] = useState(false);
    const [editingCourseId, setEditingCourseId] = useState(null);
    const [modal, setModal] = useState(false);
    const [currentStep, setCurrentStep] = useState(1);
    const [loading, setLoading] = useState(false);
    const [users, setUsers] = useState([]);
    const [categories, setCategories] = useState([]);
    const [courses, setCourses] = useState([]);
    const [openAiLoader, setOpenAiLoader] = useState(false);
    const [geminiloader, setGeminiLoader] = useState(false);
    const menuButtonStyle = {
        background: 'none',
        border: 'none',
        width: '100%',
        padding: '8px 16px',
        textAlign: 'left',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        cursor: 'pointer'
    };

    const DESCRIPTION_MIN_LENGTH = 100;
    const DESCRIPTION_MAX_LENGTH = 2000;

    const [uploadProgress, setUploadProgress] = useState({});
    const [formData, setFormData] = useState({
        thumbnail: null,
        pdf: null,
        title: '',
        description: '',
        creator_id: '',
        category_id: '',
        videos: [{ title: '', description: '', video: null, uploadId: '', isUploading: false, isUploaded: false }]
    });
    const backendUrl = process.env.REACT_APP_BACKEND_BASE_URL;
    // Animation variants
    const stepVariants = {
        enter: { opacity: 0, x: 50 },
        center: { opacity: 1, x: 0 },
        exit: { opacity: 0, x: -50 }
    };

    const handleEditCourse = async (courseId) => {
        setEditingCourseId(courseId);
        setIsEditMode(true);

        try {
            // 1. First fetch course data
            const response = await axios.get(`/api/education-course/${courseId}`);
            const course = response.data;

            // 2. Prepare form data
            const initialFormData = {
                title: course.title,
                description: course.description,
                creator_id: course.creator_id,
                category_id: course.category_id,
                videos: JSON.parse(course.videos || '[]').map(video => ({
                    title: video.title,
                    description: video.description,
                    videoId: video.video_id,
                    isUploaded: true,
                    isUploading: false,
                    uploadId: '',
                    video: {
                        name: video?.video?.name,
                        size: video?.video?.size
                    }
                })),
                editThumbnailUrl: course.thumbnail,
                thumbnail: null,
                pdf: null,
            };

            // 3. Handle thumbnail differently if CORS issues exist

            setFormData(initialFormData);
            setModal(true);
        } catch (error) {
            console.error('Error loading course:', error);
            toast.error('Failed to load course data');
        }
    };


    const generatePdf = async () => {
        setGeminiLoader(true);
        try {
            const response = await axios.post(`/api/generate-pdf`, formData, {
                responseType: 'blob'
            });

            // Create a Blob from the PDF Stream
            const file = new Blob([response.data], { type: 'application/pdf' });

            // Create a link element
            const fileURL = URL.createObjectURL(file);
            const link = document.createElement('a');
            link.href = fileURL;
            link.setAttribute('download', `course-details-${formData.title.toLowerCase().replace(/\s+/g, '-')}.pdf`);

            // Append to html, click to download and remove
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

        } catch (error) {
            console.error('Error generating PDF:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Failed to generate PDF. Please try again.',
            });
        } finally {
            setGeminiLoader(false);
        }
    }


    const generateAiDescription = async () =>{
         // 1. First fetch course data
         setOpenAiLoader(true);
         try{
             const response = await axios.post(`/api/openai/generate-paragraph`,{prompt: formData.title , words:2000});
             setFormData({...formData, description: response.data.content});

        } catch {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Failed to generate description',
            })
        } finally {
            setOpenAiLoader(false);
        }
    }

    // Fetch users and categories on component mount
    useEffect(() => {
        props.setBreadcrumbItems('Courses Management', breadcrumbItems);
        fetchUsers();
        fetchCourses();
        fetchCategories();
    }, []);

    // const [isLoading, setIsLoading] = useState(false);
    // const [searchQuery, setSearchQuery] = useState('');
    // const [searchTimeout, setSearchTimeout] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [searchTimeout, setSearchTimeout] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [totalCourses, setTotalCourses] = useState(0);
    const [isHovered, setIsHovered] = useState(false);
    const fetchCourses = async (search = '', page = 1) => {
        setIsLoading(true); // Set loading to true at the start
        try {
            const params = new URLSearchParams();
            if (search) {
                params.append('search', search);
            }
            if (page) {
                params.append('page', page);
            }
            if (perPage) {
                params.append('per_page', perPage);
            }

            const response = await axios.get(`/api/education-courses-crm${params.toString() ? `?${params.toString()}` : ''}`);
            setCourses(response.data.education_courses || []);

            if (typeof response.data.current_page !== 'undefined') {
                setCurrentPage(response.data.current_page);
            }
            if (typeof response.data.last_page !== 'undefined') {
                setLastPage(response.data.last_page);
            }
            if (typeof response.data.per_page !== 'undefined') {
                setPerPage(response.data.per_page);
            }
            if (typeof response.data.total !== 'undefined') {
                setTotalCourses(response.data.total);
            }
        } catch (error) {
            console.error('Error fetching courses:', error);
            // Optionally show an error toast/message
            toast.error('Failed to fetch courses');
        } finally {
            setIsLoading(false); // Set loading to false when done (success or error)
        }
    }

    const fetchUsers = async (query = '') => {
        if (userData.roles !== 'admin') {
            return;
        }
        axios.get(`/api/users/search?query=${query}`)
            .then(response => {
                setUsers(response.data);
            })
            .catch(error => {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: error.response?.data?.message || 'Failed to fetch organizers',
                });
            });
    };

    const fetchCategories = async () => {
        try {
            const response = await axios.get(`/api/education-categories`);
            setCategories(response.data.education_categories || []);
        } catch (error) {
            console.error('Error fetching categories:', error);
        }
    };

    const toggleModal = async (successPosted = false) => {
        const newModalState = !modal;
        setModal(newModalState);

        if (!newModalState && !successPosted) {
            if (isEditMode) {
                setIsEditMode(false);
                setEditingCourseId(null);
            }
            // When closing the modal, delete all uploaded videos from Cloudflare
            try {
                const videosToDelete = formData.videos.filter(
                    video => video.videoId && !video.isUploading
                );

                // Delete each video in parallel
                await Promise.all(
                    videosToDelete.map(video =>
                        axios.post(`/api/cloudflare/delete/${video.videoId}`)
                    )
                );
            } catch (error) {
                console.error('Error deleting videos from Cloudflare:', error);
                // Don't show error to user since modal is closing anyway
            }
        } else {
            // Reset form when opening modal
            setCurrentStep(1);
            setFormData({
                thumbnail: null,
                title: '',
                description: '',
                creator_id: '',
                category_id: '',
                pdf: null,
                videos: [{ title: '', description: '', video: null, uploadId: '', isUploading: false, isUploaded: false }]
            });
            setUploadProgress({});
            if (isEditMode) {
                setIsEditMode(false);
                setEditingCourseId(null);
            }
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            if (file.size > 200 * 1024 * 1024) { // 5MB limit
                toast.warning('Thumbnail image should be less than 200MB');
                return;
            }
            setFormData(prev => ({
                ...prev,
                thumbnail: file
            }));
        }
    };
    const [creatorSearch, setCreatorSearch] = useState('');

    useEffect(() => {
        props.setBreadcrumbItems('Courses Management', breadcrumbItems);
        fetchUsers(creatorSearch);
        fetchCourses();
        fetchCategories();
    }, []); // Add creatorSearch as a dependency

    useEffect(() => {
        fetchUsers(creatorSearch);
    }, [creatorSearch])



    // Add these new states for cropping
    const [crop, setCrop] = useState();
    const [completedCrop, setCompletedCrop] = useState(null);
    const [imgSrc, setImgSrc] = useState(null);
    const [showCropModal, setShowCropModal] = useState(false);
    const [croppedImage, setCroppedImage] = useState(null);
    const imgRef = useRef(null);
    const previewCanvasRef = useRef(null);

    // Handle search input with debounce
    const handleSearch = (e) => {
        const value = e.target.value;
        setSearchQuery(value);
        // Reset to first page whenever search changes
        setCurrentPage(1);

        // Clear previous timeout
        if (searchTimeout) {
            clearTimeout(searchTimeout);
        }

        // Set a new timeout to avoid too many API calls
        setSearchTimeout(
            setTimeout(() => {
                fetchCourses(value, 1);
            }, 500)
        );
    };

    // Add this function to handle file selection
    const onSelectFile = (e) => {
        if (e.target.files && e.target.files.length > 0) {
            const file = e.target.files[0];
            if (file.size > 200 * 1024 * 1024) { // 5MB limit
                toast.warning('Thumbnail image should be less than 200MB');
                return;
            }

            // Create image URL from the file
            const reader = new FileReader();
            reader.addEventListener('load', () => {
                setImgSrc(reader.result.toString() || '');
                setShowCropModal(true);
            });
            reader.readAsDataURL(file);
        }
    };

    // Function to handle image load
    const onImageLoad = (e) => {
        const { naturalWidth: width, naturalHeight: height } = e.currentTarget;

        // Set initial crop to center square
        const minDimension = Math.min(width, height);
        // setCrop({
        //     unit: 'px',
        //     width: minDimension,
        //     height: minDimension,
        //     x: (width - minDimension) / 2,
        //     y: (height - minDimension) / 2,
        //     aspect: 16/9 // You can change this to your preferred aspect ratio
        // });
    };

    // Function to generate cropped image
    const generateCroppedImage = () => {
        if (!completedCrop || !previewCanvasRef.current || !imgRef.current) {
            return;
        }

        const image = imgRef.current;
        const canvas = previewCanvasRef.current;
        const crop = completedCrop;

        const scaleX = image.naturalWidth / image.width;
        const scaleY = image.naturalHeight / image.height;
        const ctx = canvas.getContext('2d');
        const pixelRatio = window.devicePixelRatio;

        canvas.width = crop.width * pixelRatio;
        canvas.height = crop.height * pixelRatio;

        ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        ctx.imageSmoothingQuality = 'high';

        ctx.drawImage(
            image,
            crop.x * scaleX,
            crop.y * scaleY,
            crop.width * scaleX,
            crop.height * scaleY,
            0,
            0,
            crop.width,
            crop.height
        );

        // Convert canvas to blob
        canvas.toBlob((blob) => {
            if (!blob) {
                return;
            }

            // Create a new cropped file
            const fileName = `cropped-${Date.now()}.jpg`;
            const croppedFile = new File([blob], fileName, {
                type: 'image/jpeg',
                lastModified: Date.now()
            });

            setCroppedImage(croppedFile);
            setFormData(prev => ({
                ...prev,
                thumbnail: croppedFile
            }));

            setShowCropModal(false);
            setImgSrc(null);
        }, 'image/jpeg', 0.9); // 0.9 is the quality (0-1)
    };

    const retryUpload = async (index) => {
        const updatedVideos = [...formData.videos];
        const file = updatedVideos[index].video;
        if (file) {
            await uploadVideoToCloudflare(file, index, true);
        }
    };


    const handleVideoChange = async (index, e) => {
        const { name, value, files } = e.target;
        const updatedVideos = [...formData.videos];

        if (name === 'video') {
            const file = files[0];
            if (file) {
                // Check file size (e.g., 500MB limit)
                if (file.size > 500 * 1024 * 1024) {
                    toast.warning(`Video ${index + 1} exceeds 500MB limit`);
                    return;
                }

                updatedVideos[index] = {
                    ...updatedVideos[index],
                    video: file,
                    isUploading: true,
                    isUploaded: false
                };

                setFormData(prev => ({
                    ...prev,
                    videos: updatedVideos
                }));

                // Upload to Cloudflare Stream
                await uploadVideoToCloudflare(file, index);
            }
        } else {
            updatedVideos[index][name] = value;
            setFormData(prev => ({
                ...prev,
                videos: updatedVideos
            }));
        }
    };




    const uploadVideoToCloudflare = async (file, index, is_retry = false, is_remove = false) => {
        try {
            const uploadId = `video-${index}-${Date.now()}`;
            const filename = `video-${index}-${Date.now()}.mp4`;

            // Update form data with uploadId
            setFormData(prev => {
                const updatedVideos = [...prev.videos];
                updatedVideos[index].uploadId = uploadId;
                updatedVideos[index].isUploading = true;
                return { ...prev, videos: updatedVideos };
            });

            const endpoint = `https://api.cloudflare.com/client/v4/accounts/${process.env.REACT_APP_CLOUDFLARE_ACCOUNT_ID}/stream?tus=true`;


            // Create a new upload
            const upload = new TusUpload(file, {
                endpoint: endpoint,
                headers: {
                    Authorization: `Bearer ${process.env.REACT_APP_CLOUDFLARE_API_TOKEN}`,
                },
                chunkSize: 50 * 1024 * 1024, // 50MB chunks
                retryDelays: [0, 1000, 3000, 5000],
                metadata: {
                    filename: filename,
                    filetype: file.type
                },
                onError: (error) => {
                    console.error('Upload error:', error);
                    setFormData(prev => {
                        const updatedVideos = [...prev.videos];
                        updatedVideos[index].isUploading = false;
                        updatedVideos[index].isUploaded = false;
                        return { ...prev, videos: updatedVideos };
                    });
                    toast.error(`Upload failed for video ${index + 1}: ${error.message}`);
                },
                onProgress: (bytesUploaded, bytesTotal) => {
                    const progress = Math.round((bytesUploaded / bytesTotal) * 100);
                    setUploadProgress(prev => ({
                        ...prev,
                        [uploadId]: progress
                    }));
                },
                onSuccess: () => {
                    // Get the video ID from the upload URL
                    const videoUrl = upload.url;
                    const uid = videoUrl.split('/').pop().split('?')[0];

                    setFormData(prev => {
                        const updatedVideos = [...prev.videos];
                        updatedVideos[index].isUploading = false;
                        updatedVideos[index].isUploaded = true;
                        updatedVideos[index].videoId = uid;
                        updatedVideos[index].name = filename;
                        updatedVideos[index].size = file.size;
                        return { ...prev, videos: updatedVideos };
                    });

                    toast.success(`Video ${index + 1} uploaded successfully!`);
                }
            });
            if (is_remove) {
                upload.abort();
            }

            // Check if there's a previous upload to resume
            upload.findPreviousUploads().then((previousUploads) => {
                if (previousUploads.length && is_retry) {
                    upload.resumeFromPreviousUpload(previousUploads[0]);
                } else {
                    upload.start();
                }
            });

        } catch (error) {
            console.error('Upload initialization error:', error);
            setFormData(prev => {
                const updatedVideos = [...prev.videos];
                updatedVideos[index].isUploading = false;
                updatedVideos[index].isUploaded = false;
                return { ...prev, videos: updatedVideos };
            });
            toast.error(`Upload failed for video ${index + 1}: ${error.message}`);
        }
    };

    const addVideoField = () => {
        if (formData.videos.length < 100) {
            setFormData(prev => ({
                ...prev,
                videos: [...prev.videos, {
                    title: '',
                    description: '',
                    video: null,
                    uploadId: '',
                    isUploading: false,
                    isUploaded: false
                }]
            }));
        } else {
            toast.warning('Maximum 100 videos allowed');
        }
    };

    const handleAddCategory = async () => {
        try {
            // Convert tags string to array
            const payload = {
                ...newCategory,
                tags: newCategory.tags ? newCategory.tags.split(',').map(tag => tag.trim()) : []
            };

            const response = await axios.post('/api/education/category', payload);
            toast.success('Category added successfully');

            // Add the new category to the categories list
            setCategories(prev => [...prev, response.data?.data]);

            // Select the new category
            setFormData(prev => ({
                ...prev,
                category_id: response.data?.data?.id
            }));

            // Close the modal and reset the form
            setShowCategoryModal(false);
            setNewCategory({ name: '', tags: '' });
        } catch (error) {
            console.error('Error adding category:', error);
            toast.error('Failed to add category');
        }
    };

    const formatDuration = (totalSeconds) => {
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = Math.floor(totalSeconds % 60);

        if (hours > 0) {
            return `${hours}h ${minutes}m ${seconds}s`;
        } else {
            return `${minutes}m ${seconds.toString().padStart(2, '0')}s`;
        }
    };

    const removeVideo = async (index) => {
        // if (formData.videos.length <= 1) {
        //     toast.warning('You must have at least one video in the course');
        //     return;
        // }

        const videoToRemove = formData.videos[index];
        console.log(videoToRemove);
        // If the video was uploaded to Cloudflare, delete it first
        if (videoToRemove.videoId && !videoToRemove.isUploading) {
            try {
                await axios.post(`/api/cloudflare/delete/${videoToRemove.videoId}`);

                toast.success(`Video ${index + 1} removed successfully`);
            } catch (error) {
                console.error('Error deleting video from Cloudflare:', error);
                toast.error(`Failed to delete video from Cloudflare: ${error.response?.data?.message || error.message}`);
                // We'll still remove it from the UI but log the error
            }
        }
        const updatedVideos = [...formData.videos];
        const file = updatedVideos[index].video;
        updatedVideos[index].video = null;
        setFormData(prev => ({
            ...prev,
            videos: updatedVideos
        }));
        await uploadVideoToCloudflare(file, index, false, true);
    };

    const removeVideoField = async (index) => {
        try {
            // Don't proceed if there's only one video left
            if (formData.videos.length <= 1) {
                toast.warning('You must have at least one video in the course');
                return;
            }

            const videoToRemove = formData.videos[index];
            console.log(videoToRemove);
            // If the video was uploaded to Cloudflare, delete it first
            if (videoToRemove.videoId && !videoToRemove.isUploading) {
                try {
                    await axios.post(`/api/cloudflare/delete/${videoToRemove.videoId}`);

                    toast.success(`Video ${index + 1} removed successfully`);
                } catch (error) {
                    console.error('Error deleting video from Cloudflare:', error);
                    toast.error(`Failed to delete video from Cloudflare: ${error.response?.data?.message || error.message}`);
                    // We'll still remove it from the UI but log the error
                }
            }

            // Remove the video from the local state
            const updatedVideos = [...formData.videos];
            updatedVideos.splice(index, 1);

            setFormData(prev => ({
                ...prev,
                videos: updatedVideos
            }));

        } catch (error) {
            console.error('Error removing video:', error);
            toast.error('Failed to remove video');
        }
    };

    const nextStep = (e) => {
        setCurrentStep(prev => {
            e.preventDefault();
            const next = prev + 1;
            console.log("Next clicked. Current step:", next);
            return next;
        });
    };

    const prevStep = () => {
        setCurrentStep(currentStep - 1);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        // if (currentStep !== 3) return;

        setLoading(true);

        try {
            const formDataToSend = new FormData();
            formDataToSend.append('_method', isEditMode ? 'PUT' : 'POST');
            formDataToSend.append('thumbnail', formData.thumbnail);
            formDataToSend.append('title', formData.title);
            formDataToSend.append('description', formData.description);
            if (formData.pdf != null) {
                formDataToSend.append('pdf', formData.pdf)
            }
            formDataToSend.append('creator_id', formData.creator_id);
            formDataToSend.append('category_id', formData.category_id);

            formData.videos.forEach((video, index) => {
                formDataToSend.append(`videos[${index}][title]`, video.title);
                if (video.description) {
                    formDataToSend.append(`videos[${index}][description]`, video.description);
                }
                formDataToSend.append(`videos[${index}][video][name]`, video.name);
                formDataToSend.append(`videos[${index}][video][size]`, video.size);
                if (video.videoId) {
                    formDataToSend.append(`videos[${index}][video_id]`, video.videoId);
                }
            });

            const url = isEditMode
                ? `/api/education-course/${editingCourseId}`
                : '/api/create-education-course';

            const response = await axios.post(url, formDataToSend, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });

            toast.success(`Course ${isEditMode ? 'updated' : 'created'} successfully!`);
            fetchCourses();
            toggleModal(true);
        } catch (error) {
            console.error(`Error ${isEditMode ? 'updating' : 'creating'} course:`, error);
            toast.error(error.response?.data?.message || `Failed to ${isEditMode ? 'update' : 'create'} course`);
        } finally {
            setLoading(false);
        }
    };


    const handleDeleteCourse = async (id) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'Cancel'
        });

        if (result.isConfirmed) {
            try {
                await axios.delete(`/api/education-course/${id}`);
                toast.success('Course deleted successfully!');
                fetchCourses();
            } catch (error) {
                console.error('Error deleting course:', error);
                toast.error(error.response?.data?.message || 'Failed to delete course');
            }
        }
    };

    const renderThumbnailUpload = () => (
        <FormGroup>
            <Label>Thumbnail Image</Label>
            <div className="thumbnail-upload-container">
                <label className="thumbnail-upload-box">
                    {formData.thumbnail ? (
                        <div className="thumbnail-preview">
                            <img
                                src={URL.createObjectURL(formData.thumbnail)}
                                alt="Thumbnail preview"
                            />
                            <button
                                type="button"
                                className="btn btn-danger btn-sm remove-thumbnail"
                                onClick={() => setFormData(prev => ({ ...prev, thumbnailUrl: null, thumbnail: null }))}
                            >
                                <X size={16} />
                            </button>
                        </div>
                    ) : formData.editThumbnailUrl ? (
                        <div className="thumbnail-preview">
                            <img
                                src={formData.editThumbnailUrl}
                                alt="Thumbnail preview"
                            />
                            <button
                                type="button"
                                className="btn btn-danger btn-sm remove-thumbnail"
                                onClick={() => setFormData(prev => ({ ...prev, editThumbnailUrl: null, thumbnail: null }))}
                            >
                                <X size={16} />
                            </button>
                        </div>
                    ) : (
                        <div className="upload-placeholder">
                            <Image size={48} className="text-muted mb-2" />
                            <span>Click to upload thumbnail</span>
                            <span className="text-muted small">(Recommended: 800x450, max 200MB)</span>
                        </div>
                    )}
                    <Input
                        type="file"
                        accept="image/*"
                        onChange={onSelectFile}
                        className="d-none"
                    />
                </label>
            </div>
        </FormGroup>
    );

    const renderStepContent = () => {
        switch (currentStep) {
            case 1:
                return (
                    <motion.div
                        key="step1"
                        initial="enter"
                        animate="center"
                        exit="exit"
                        variants={stepVariants}
                        transition={{ duration: 0.3 }}
                    >
                        {renderThumbnailUpload()}
                        <FormGroup>
                            <Label>Category *</Label>
                            <InputGroup>
                                <Input
                                    type="select"
                                    name="category_id"
                                    value={formData.category_id}
                                    onChange={handleInputChange}
                                    required
                                    className="form-select"
                                >
                                    <option value="">Select Category</option>
                                    {categories.map(category => (
                                        <option key={category.id} value={category.id}>
                                            {category.name}
                                        </option>
                                    ))}
                                </Input>
                                <Button
                                    color="primary"
                                    onClick={() => setShowCategoryModal(true)}
                                    className="ms-0"
                                >
                                    <i className="mdi mdi-plus"></i>
                                </Button>
                            </InputGroup>
                        </FormGroup>
                        <FormGroup>
                            <Label>Course Title <span >* (Minimum 10 characters required)</span></Label>
                            <Input
                                type="text"
                                name="title"
                                value={formData.title}
                                onChange={handleInputChange}
                                required
                                minLength="10"
                                className="form-control"
                            />
                        </FormGroup>
                        <FormGroup>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'bottom' }}>
                                <Label>Description (Minimum 100 Character required)*</Label>

                                {formData.title && formData.title.length >= 10 && (
                                    <div
                                        onClick={() => !openAiLoader && generateAiDescription()}
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '6px',
                                            color: openAiLoader ? '#999' : '#10a37f',
                                            cursor: openAiLoader ? 'not-allowed' : 'pointer',
                                            padding: '4px 8px',
                                            borderRadius: '4px',
                                            transition: 'all 0.2s',
                                            fontSize: '13px',
                                            fontWeight: 500,
                                            background: openAiLoader ? '#f5f5f5' : 'rgba(16, 163, 127, 0.1)',
                                            opacity: openAiLoader ? 0.8 : 1,
                                            marginBototm: '4px'
                                        }}
                                        onMouseOver={(e) => {
                                            if (!openAiLoader) {
                                                e.currentTarget.style.background = 'rgba(16, 163, 127, 0.15)';
                                                e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.1)';
                                            }
                                        }}
                                        onMouseOut={(e) => {
                                            e.currentTarget.style.background = openAiLoader ? '#f5f5f5' : 'rgba(16, 163, 127, 0.1)';
                                            e.currentTarget.style.boxShadow = 'none';
                                        }}
                                        title={openAiLoader ? "Generating description..." : "Generate description using AI"}
                                    >
                                        {openAiLoader ? (
                                            <span className="spinner-border spinner-border-sm me-1" role="status" />
                                        ) : (
                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z" fill="currentColor" />
                                                <path d="M13 7H11V13H17V11H13V7Z" fill="currentColor" />
                                            </svg>
                                        )}
                                        <span>{openAiLoader ? 'Generating...' : 'Generate with AI'}</span>
                                    </div>
                                )}
                            </div>

                            <div style={{ position: 'relative' }}>
                                {openAiLoader && (
                                    <div style={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        right: 0,
                                        bottom: 0,
                                        backgroundColor: 'rgba(255, 255, 255, 0.7)',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        zIndex: 2,
                                        borderRadius: '4px'
                                    }}>
                                        <div className="spinner-border text-primary" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    </div>
                                )}
                                <Input
                                    type="textarea"
                                    name="description"
                                    value={formData.description}
                                    onChange={handleInputChange}
                                    rows="5"
                                    className="form-control-lg"
                                    minLength={DESCRIPTION_MIN_LENGTH}
                                    maxLength={DESCRIPTION_MAX_LENGTH}
                                    required
                                    disabled={openAiLoader}
                                    style={{
                                        backgroundColor: openAiLoader ? '#f8f9fa' : '#fff',
                                        position: 'relative',
                                        zIndex: 1
                                    }}
                                />
                            </div>

                            <div className={`text-end small mt-1 ${formData.description.length < DESCRIPTION_MIN_LENGTH ? 'text-danger' :
                                formData.description.length >= DESCRIPTION_MAX_LENGTH ? 'text-danger' : 'text-muted'
                                }`}>
                                {formData.description.length}/{DESCRIPTION_MAX_LENGTH} characters
                            </div>
                        </FormGroup>
                    </motion.div>
                );

            case 2:
                return (
                    <motion.div
                        key="step3"
                        initial="enter"
                        animate="center"
                        exit="exit"
                        variants={stepVariants}
                        transition={{ duration: 0.3 }}
                    >
                        <div className="mb-4">
                            <h5>Course Videos</h5>
                            <p className="text-muted">Upload your course videos to Cloudflare Stream</p>
                        </div>

                        <div className="video-upload-list">
                            {formData.videos.map((video, index) => (
                                <div key={index} className="video-upload-card mb-3">
                                    <div className="video-upload-header">
                                        <h6>Video {index + 1}</h6>
                                        {formData.videos.length > 1 && (
                                            <button
                                                type="button"
                                                className="btn btn-sm btn-outline-danger"
                                                onClick={() => removeVideoField(index)}
                                                disabled={video.isUploading}
                                            >
                                                Remove
                                            </button>
                                        )}
                                    </div>

                                    <FormGroup className="mt-2">
                                        <Label>Video Title * (Minimum 5 characters required)</Label>
                                        <Input
                                            type="text"
                                            name="title"
                                            value={video.title}
                                            onChange={(e) => handleVideoChange(index, e)}
                                            required
                                            minLength="5"
                                            maxLength="150"
                                            className="form-control"
                                        />
                                    </FormGroup>


                                    <FormGroup className="mt-2">
                                        <Label>Video Description (Optional)</Label>
                                        <Input
                                            type="textarea"
                                            name="description"
                                            value={video.description}
                                            onChange={(e) => handleVideoChange(index, e)}
                                            rows="5"
                                            className="form-control"
                                            maxLength={DESCRIPTION_MAX_LENGTH}
                                            required
                                        />
                                        <div className={`text-end small mt-1 ${video.description.length >= DESCRIPTION_MAX_LENGTH ? 'text-danger' : 'text-muted'
                                            }`}>
                                            {video.description.length}/{DESCRIPTION_MAX_LENGTH} characters
                                        </div>

                                    </FormGroup>

                                    <FormGroup>
                                        <div className="d-flex align-items-center justify-content-between mb-1">
                                            <Label>Video File *</Label>
                                            <div>
                                                <button
                                                    type="button"
                                                    className="btn btn-sm btn-outline-warning"
                                                    onClick={() => retryUpload(index)}
                                                    disabled={video.isUploading}
                                                >
                                                    Retry
                                                </button>
                                                &nbsp;
                                                &nbsp;
                                                <button
                                                    type="button"
                                                    className="btn btn-sm btn-outline-danger"
                                                    onClick={() => removeVideo(index)}
                                                >
                                                    Remove
                                                </button>
                                            </div>
                                        </div>
                                        <div className="video-upload-box">
                                            {video?.video ? (
                                                <div className="video-upload-preview">
                                                    <div className="video-info">
                                                        <Video size={24} className="text-primary me-2" />
                                                        <div>
                                                            <div className="video-name">{video?.video?.name}</div>
                                                            <div className="video-size">
                                                                {(video?.video?.size / (1024 * 1024).toFixed(2))} MB
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {video?.isUploading && (
                                                        <div className="upload-progress">
                                                            <Progress
                                                                value={uploadProgress[video.uploadId] || 0}
                                                                className="mb-2"
                                                            />
                                                            <div className="d-flex justify-content-between">
                                                                <small className="text-muted">
                                                                    {uploadProgress[video.uploadId] || 0}% Uploaded
                                                                </small>
                                                                <Loader size={16} className="spin" />
                                                            </div>
                                                        </div>
                                                    )}

                                                    {video?.isUploaded && (
                                                        <div className="upload-complete text-success">
                                                            <Check size={16} className="me-1" /> Upload Complete
                                                        </div>
                                                    )}
                                                </div>
                                            ) : (
                                                <>
                                                    <label className="video-upload-placeholder">
                                                        <span>Click to upload video</span>
                                                        <span className="text-muted small">(MP4, max 500MB)</span>
                                                        <Input
                                                            type="file"
                                                            name="video"
                                                            accept="video/mp4,video/x-m4v,video/*"
                                                            onChange={(e) => handleVideoChange(index, e)}
                                                            required={index === 0 && !isEditMode}
                                                            className="d-none"
                                                        />
                                                    </label>
                                                </>
                                            )}
                                        </div>
                                    </FormGroup>
                                </div>
                            ))}
                        </div>

                        <Button
                            color="light"
                            className="mt-2 w-100"
                            onClick={addVideoField}
                            disabled={formData.videos.length >= 100}
                        >
                            + Add Another Video
                        </Button>
                        <div className="text-muted mt-2 text-center">
                            {formData.videos.length}/100 videos added
                        </div>
                    </motion.div>
                );



            case 3:
                return (
                    <motion.div
                        key="step2"
                        initial="enter"
                        animate="center"
                        exit="exit"
                        variants={stepVariants}
                        transition={{ duration: 0.3 }}
                    >
                        {/* {userData.roles == 'admin' && (
                        <FormGroup>
                            <Label>Creator (Optional)</Label>
                            <Select
                                name="creator_id"
                                value={formData.creator_id ? {
                                    value: formData.creator_id,
                                    label: users.find(user => user.id === formData.creator_id)?.name ||
                                        users.find(user => user.id === formData.creator_id)?.email
                                } : null}
                                onChange={(selectedOption) => {
                                    setFormData(prev => ({
                                        ...prev,
                                        creator_id: selectedOption ? selectedOption.value : ''
                                    }));
                                    // Clear the search after selection
                                    // setCreatorSearch('');
                                }}
                                onInputChange={(inputValue, { action }) => {
                                    // Only update search when user is typing, not when selecting
                                    if (action === 'input-change') {
                                        setCreatorSearch(inputValue);
                                    }
                                }}
                                // onMenuClose={() => setCreatorSearch('')}
                                options={users.map(user => ({
                                    value: user.id,
                                    label: user.name || user.email
                                }))}
                                isClearable
                                placeholder="Search and select creator..."
                                className="react-select-container"
                                classNamePrefix="react-select"
                                isLoading={isLoading}
                                loadingMessage={() => "Loading..."}
                                noOptionsMessage={() => "No creators found"}
                            />
                        </FormGroup>
                        )} */}


                        <FormGroup>
                            <Label>Upload PDF (Optional)</Label>
                            <div className="d-flex gap-2">
                                <InputGroup className="flex-grow-1">
                                    <Input
                                        type="file"
                                        name="pdf"
                                        accept=".pdf"
                                        onChange={(e) => {
                                            const file = e.target.files[0];
                                            formData.pdf = file;
                                            setFormData({ ...formData, pdf: file });
                                        }}
                                    />
                                </InputGroup>
                                <Button
                                    color="primary"
                                    className="d-flex align-items-center gap-1"
                                    onClick={() => { generatePdf(); }}
                                >
                                    <i className="mdi mdi-file-pdf-box"></i> Generate PDF
                                </Button>
                            </div>
                        </FormGroup>

                    </motion.div>
                );

            default:
                return null;
        }
    };

    return (
        <React.Fragment>
            <ToastContainer position="top-right" autoClose={5000} />
            <div className="d-flex justify-content-between align-items-center mb-4">
                <div>
                    <CardTitle tag="h4" className="mb-1">Courses Management Dashboard</CardTitle>
                    <p className="text-muted mb-0">
                        Manage and view courses with course images, names, course dates, and descriptions.
                    </p>
                </div>
                <div className="d-flex justify-content-end gap-2 align-items-center">
                    <div className="search-box">
                        <div className="position-relative"
                            style={{ minWidth: '350px', maxWidth: '500px', width: '100%' }}>
                            <Input
                                type="text"
                                className="form-control bg-light"
                                placeholder="Search courses by title, description, or creator..."
                                value={searchQuery}
                                onChange={handleSearch}
                            />
                            <i className="ri-search-line search-icon"></i>
                        </div>
                    </div>
                    <button
                        className="btn btn-primary"
                        onClick={toggleModal}
                        disabled={loading}
                        style={{ minWidth: 'fit-content' }}
                    >
                        <i className="bx bx-plus me-1"></i> Add New Course
                    </button>
                </div>
            </div>
            <Row className="g-3">
                {isLoading ? (
                    <div className="text-center my-4">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                ) : (
                    courses.map((course) => {
                        const videoList = JSON.parse(course?.videos || '[]');
                        const totalVideos = videoList.length;
                        const inSecond = videoList.reduce((total, video) => total + video.video_duration, 0);
                        const estimatedDuration = formatDuration(inSecond);

                        return (

                            <Col key={course?.id} md="6" lg={4} xxl={3}>
                                <div className="position-relative rounded-4 overflow-hidden h-100">
                                    {/* Card Content Link */}
                                    <Link to={`/courses-management/course/${course?.id}`} className="text-decoration-none text-dark">
                                        <Card className="flex-row flex-wrap shadow-lg hover-shadow h-100">

                                            {/* Thumbnail */}
                                            {course?.thumbnail && (
                                                <div
                                                    className="image-container"
                                                    style={{
                                                        position: 'relative',
                                                        width: '100%',
                                                        paddingBottom: '56.25%',
                                                        overflow: 'hidden',
                                                        borderRadius: '0px',
                                                        cursor: 'pointer',
                                                    }}
                                                >
                                                    <img
                                                        src={PlayIcon}
                                                        alt="Play Icon"
                                                        style={{
                                                            position: 'absolute',
                                                            top: '50%',
                                                            left: '50%',
                                                            transform: 'translate(-50%, -50%)',
                                                            zIndex: 9,
                                                            width: '84px',
                                                            border: '3px solid #fff',
                                                            padding: '16px',
                                                            borderRadius: '50%',
                                                            height: '84px',
                                                            opacity: 0.6
                                                        }}
                                                    />
                                                    <img
                                                        src={course.thumbnail}
                                                        alt={course.title}
                                                        style={{
                                                            position: 'absolute',
                                                            top: 0,
                                                            left: 0,
                                                            width: '100%',
                                                            height: '100%',
                                                            objectFit: 'cover',
                                                        }}
                                                    />

                                                    {/* Dark overlay */}
                                                    <div
                                                        style={{
                                                            position: 'absolute',
                                                            top: 0,
                                                            left: 0,
                                                            width: '100%',
                                                            height: '100%',
                                                            background: 'rgba(0, 0, 0, 0.3)',
                                                            zIndex: 1,
                                                        }}
                                                    />

                                                    {/* Creator badge top-left */}
                                                    <div
                                                        style={{
                                                            position: 'absolute',
                                                            top: '10px',
                                                            left: '10px',
                                                            zIndex: 2,
                                                            fontFamily: 'Space Grotesk',
                                                            textTransform: 'uppercase',
                                                        }}
                                                    >
                                                        <strong style={{
                                                            backgroundColor: '#fff',
                                                            padding: '4px 10px 3px',
                                                            borderRadius: '4px',
                                                            fontSize: '9px',
                                                        }}>
                                                            {course?.creator?.name || 'Unknown'}
                                                        </strong>
                                                    </div>

                                                    {/* Duration bottom-right */}
                                                    <div
                                                        style={{
                                                            position: 'absolute',
                                                            bottom: '10px',
                                                            right: '10px',
                                                            backgroundColor: '#fff',
                                                            padding: '4px 10px 3px',
                                                            borderRadius: '4px',
                                                            fontSize: '9px',
                                                            fontWeight: 500,
                                                            zIndex: 2,
                                                            color: '#000',
                                                        }}
                                                    >
                                                        ~{estimatedDuration}
                                                    </div>
                                                </div>
                                            )}

                                            {/* Card Body */}
                                            <CardBody className="d-flex flex-column justify-content-between p-3" style={{ minHeight: '100px' }}>
                                                <div>
                                                    <CardTitle
                                                        tag="h5"
                                                        className="mb-1"
                                                        style={{ fontFamily: 'Space Grotesk', textTransform: 'uppercase' }}
                                                    >
                                                        {course?.title}
                                                    </CardTitle>
                                                    <p
                                                        className="text-muted mb-1"
                                                        style={{
                                                            fontFamily: 'Space Grotesk',
                                                            display: '-webkit-box',
                                                            WebkitLineClamp: 3,
                                                            WebkitBoxOrient: 'vertical',
                                                            overflow: 'hidden',
                                                            textOverflow: 'ellipsis',
                                                        }}
                                                    >
                                                        {course?.description}
                                                    </p>
                                                </div>
                                            </CardBody>
                                        </Card>
                                    </Link>

                                    {/* 3-Dot Menu - Outside Link to prevent navigation */}
                                    <div
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            e.preventDefault();
                                            setMenuOpen(menuOpen === course.id ? null : course.id);
                                        }}
                                        style={{
                                            position: 'absolute',
                                            top: '10px',
                                            right: '10px',
                                            zIndex: 3,
                                            cursor: 'pointer',
                                        }}
                                    >
                                        <FiMoreVertical size={20} color="#fff" />

                                        {menuOpen === course.id && (
                                            <div
                                                style={{
                                                    position: 'absolute',
                                                    top: '30px',
                                                    right: '0',
                                                    background: '#fff',
                                                    borderRadius: '6px',
                                                    boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                                                    padding: '8px 0',
                                                    zIndex: 4,
                                                    width: '120px',
                                                }}
                                            >
                                                <button
                                                    onClick={() => handleEditCourse(course.id)}
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '6px',
                                                        padding: '8px 12px',
                                                        width: '100%',
                                                        background: 'none',
                                                        border: 'none',
                                                        cursor: 'pointer',
                                                    }}
                                                >
                                                    <FiEdit2 /> Edit
                                                </button>
                                                <button
                                                    onClick={() => navigate(`/courses-management/course/${course?.id}`)}
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '6px',
                                                        padding: '8px 12px',
                                                        width: '100%',
                                                        background: 'none',
                                                        border: 'none',
                                                        cursor: 'pointer',
                                                    }}
                                                >
                                                    <FiEye /> Details
                                                </button>
                                                <button
                                                    onClick={() => handleDeleteCourse(course.id)}
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '6px',
                                                        padding: '8px 12px',
                                                        width: '100%',
                                                        background: 'none',
                                                        border: 'none',
                                                        color: 'red',
                                                        cursor: 'pointer',
                                                    }}
                                                >
                                                    <FiTrash2 /> Delete
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </Col>
                        );
                    })
                )}
            </Row>
            <div className="d-flex justify-content-between align-items-center my-3">
                <div>
                    Showing {(currentPage - 1) * perPage + 1}
                    {' - '}
                    {Math.min(currentPage * perPage, totalCourses)}
                    {' of '}
                    {totalCourses} courses
                </div>

                <div className="d-flex align-items-center gap-2">
                    <Button
                        color="primary"
                        size="sm"
                        disabled={currentPage <= 1 || isLoading}
                        onClick={() => fetchCourses(searchQuery, currentPage - 1)}
                    >
                        Previous
                    </Button>

                    <span className="mx-2">
                        Page {currentPage} of {lastPage}
                    </span>

                    <Button
                        color="primary"
                        size="sm"
                        disabled={currentPage >= lastPage || isLoading}
                        onClick={() => fetchCourses(searchQuery, currentPage + 1)}
                    >
                        Next
                    </Button>
                </div>
            </div>


            {/* Create Course Modal */}
            <Modal isOpen={modal} toggle={toggleModal} className="create-course-modal" size="lg" backdrop={false} centered>

                <ModalHeader toggle={toggleModal}>
                    <h5 className="modal-title">{isEditMode ? 'Edit Course' : 'Create New Course'}</h5>
                </ModalHeader>
                <Form onSubmit={handleSubmit}>
                    <ModalBody>
                        <div className="wizard">
                            <div className="steps-progress">
                                <div className="step-indicators">
                                    <div className={`step ${currentStep === 1 ? 'active' : ''}`}>
                                        <div className="step-number">1</div>
                                        <div className="step-label">Basic Info</div>
                                    </div>
                                    <div className={`step ${currentStep === 2 ? 'active' : ''}`}>
                                        <div className="step-number">2</div>
                                        <div className="step-label">Videos</div>
                                    </div>
                                    <div className={`step ${currentStep === 3 ? 'active' : ''}`}>
                                        <div className="step-number">3</div>
                                        <div className="step-label">Upload Pdf</div>
                                    </div>
                                </div>
                                <Progress
                                    value={(currentStep / 3) * 100}
                                    className="wizard-progress"
                                />
                            </div>

                            <div className="step-content">
                                <AnimatePresence mode="wait">
                                    {renderStepContent()}
                                </AnimatePresence>
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter className="border-top">
                        <div className="d-flex justify-content-between w-100 m-0">
                            <Button
                                color="light"
                                type="button"
                                onClick={currentStep === 1 ? toggleModal : prevStep}
                                disabled={loading}
                            >
                                {currentStep === 1 ? 'Cancel' : 'Back'}
                            </Button>
                            <div>
                                {currentStep < 3 ? (
                                    <Button
                                        color="primary"
                                        type="button"
                                        onClick={nextStep}
                                        disabled={loading ||
                                            (currentStep === 1 && (
                                                !formData.title ||
                                                (!isEditMode && !formData.thumbnail) ||
                                                formData.description.length < DESCRIPTION_MIN_LENGTH || formData.description.length > DESCRIPTION_MAX_LENGTH || formData.title.length < 10 || !formData.category_id
                                            )) ||
                                            (currentStep === 2 && (!formData.videos[0]?.title || (!isEditMode && !formData.videos[0]?.isUploaded) || formData.videos.some(v => v.isUploading)))
                                        }
                                    >
                                        Next <i className="bx bx-chevron-right ms-1"></i>
                                    </Button>
                                ) : (
                                    <Button
                                        color="success"
                                        type="submit"
                                        disabled={loading || currentStep !== 3 ||
                                            !formData.videos[0]?.title ||
                                            (!isEditMode && !formData.videos[0]?.isUploaded) ||
                                            formData.videos.some(v => v.isUploading)
                                        }
                                    >
                                        {loading ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                {isEditMode ? 'Updating...' : 'Creating...'}
                                            </>
                                        ) : isEditMode ? 'Update Course' : 'Create Course'}
                                    </Button>

                                )}
                            </div>
                        </div>
                    </ModalFooter>
                </Form>
            </Modal>
            <Modal isOpen={showCategoryModal} backdrop={false} toggle={() => setShowCategoryModal(false)}>
                <ModalHeader toggle={() => setShowCategoryModal(false)}>Add New Category</ModalHeader>
                <ModalBody>
                    <FormGroup>
                        <Label>Category Name</Label>
                        <Input
                            type="text"
                            value={newCategory.name}
                            onChange={(e) => setNewCategory({ ...newCategory, name: e.target.value })}
                            placeholder="Enter category name"
                        />
                    </FormGroup>
                    <FormGroup>
                        <Label>Tags (comma separated)</Label>
                        <Input
                            type="text"
                            value={newCategory.tags}
                            onChange={(e) => setNewCategory({ ...newCategory, tags: e.target.value })}
                            placeholder="tag1, tag2, tag3"
                        />
                    </FormGroup>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={() => setShowCategoryModal(false)}>Cancel</Button>
                    <Button color="primary" onClick={handleAddCategory}>Add Category</Button>
                </ModalFooter>
            </Modal>

            {/* Add these styles to your CSS */}
            <style jsx>{`
                .thumbnail-upload-container {
                    margin-bottom: 1.5rem;
                }
                .thumbnail-upload-box {
                    display: block;
                    border: 2px dashed #dee2e6;
                    border-radius: 8px;
                    padding: 2rem;
                    text-align: center;
                    cursor: pointer;
                    transition: all 0.3s;
                    position: relative;
                }
                .thumbnail-upload-box:hover {
                    border-color: #727cf5;
                    background-color: rgba(114, 124, 245, 0.05);
                }
                .thumbnail-preview {
                    position: relative;
                    max-width: 100%;
                }
                .thumbnail-preview img {
                    max-width: 100%;
                    max-height: 300px;
                    border-radius: 6px;
                }
                .remove-thumbnail {
                    position: absolute;
                    top: -10px;
                    right: -10px;
                    width: 28px;
                    height: 28px;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding: 0;
                }
                .upload-placeholder {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                }
                
                .video-upload-card {
                    border: 1px solid #e9ecef;
                    border-radius: 8px;
                    padding: 1.25rem;
                    background: #f8f9fa;
                }
                .video-upload-header {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 1rem;
                }
                .video-upload-box {
                    border: 2px dashed #dee2e6;
                    border-radius: 8px;
                    padding: 1.5rem;
                    text-align: center;
                    cursor: pointer;
                    transition: all 0.3s;
                }
                .video-upload-box:hover {
                    border-color: #727cf5;
                    background-color: rgba(114, 124, 245, 0.05);
                }
                .video-upload-preview {
                    text-align: left;
                }
                .video-info {
                    display: flex;
                    align-items: center;
                    margin-bottom: 1rem;
                }
                .video-name {
                    font-weight: 500;
                }
                .video-size {
                    font-size: 0.8rem;
                    color: #6c757d;
                }
                .upload-progress {
                    margin-top: 1rem;
                }
                .upload-complete {
                    display: flex;
                    align-items: center;
                    margin-top: 1rem;
                    font-weight: 400;
                }
                .video-upload-placeholder {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                }
                
                /* Wizard progress */
                .steps-progress {
                    margin-bottom: 1rem;
                    position: relative;
                }
                .step-indicators {
                    display: flex;
                    justify-content: space-between;
                    position: relative;
                    z-index: 1;
                }
                .step {
                    text-align: center;
                    flex: 1;
                    position: relative;
                }
                .step-number {
                    width: 36px;
                    height: 36px;
                    border-radius: 50%;
                    background: #e9ecef;
                    color: #6c757d;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin: 0 auto 0.5rem;
                    font-weight: 400;
                    border: 3px solid white;
                }
                .step.active .step-number {
                    background: #727cf5;
                    color: white;
                }
                .step-label {
                    font-size: 0.8rem;
                    color: #6c757d;
                }
                .step.active .step-label {
                    color: #727cf5;
                    font-weight: 500;
                }
                .wizard-progress {
                    position: absolute;
                    top: 18px;
                    left: 0;
                    right: 0;
                    height: 4px;
                    z-index: 0;
                }
                
                /* Animation for spinner */
                .spin {
                    animation: spin 1s linear infinite;
                }
                @keyframes spin {
                    from { transform: rotate(0deg); }
                    to { transform: rotate(360deg); }
                }
            `}</style>
            <style jsx>{`
                .react-select-container {
                    font-size: 16px;
                }
                .react-select__control {
                    min-height: 46px;
                    border-radius: 0.25rem;
                    border: 1px solid #ced4da;
                }
                .react-select__control--is-focused {
                    border-color: #80bdff;
                    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
                }
                .react-select__menu {
                    z-index: 1000;
                }
                    .ReactCrop {
                    margin: 0 auto;
                }
                .ReactCrop__crop-selection {
                    border: 2px dashed rgba(255, 255, 255, 0.8);
                    box-shadow: 0 0 0 9999em rgba(0, 0, 0, 0.5);
                }
                .ReactCrop__drag-handle::after {
                    background: #fff;
                    border: 1px solid #377dff;
                    height: 10px;
                    width: 10px;
                }
                .ReactCrop__drag-bar {
                    background: #377dff;
                }
            `}</style>
            <Modal isOpen={showCropModal} toggle={() => setShowCropModal(false)} backdrop={false} size="lg" centered>
                <ModalHeader toggle={() => setShowCropModal(false)}>Crop Thumbnail</ModalHeader>
                <ModalBody className="text-center">
                    {imgSrc && (
                        <ReactCrop
                            crop={crop}
                            onChange={(c) => setCrop(c)}
                            onComplete={(c) => setCompletedCrop(c)}
                            aspect={16 / 9} // Set your desired aspect ratio
                            minWidth={400} // Minimum width
                            minHeight={225} // Minimum height (for 16:9 aspect)
                            ruleOfThirds
                        >
                            <img
                                ref={imgRef}
                                alt="Crop me"
                                src={imgSrc}
                                onLoad={onImageLoad}
                                style={{ maxWidth: '100%', maxHeight: '70vh' }}
                            />
                        </ReactCrop>
                    )}

                    {/* Hidden canvas for cropping */}
                    <div style={{ display: 'none' }}>
                        <canvas
                            ref={previewCanvasRef}
                            style={{
                                border: '1px solid black',
                                objectFit: 'contain',
                                width: completedCrop?.width,
                                height: completedCrop?.height,
                            }}
                        />
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={() => setShowCropModal(false)} style={{ zIndex: 1050 }}>
                        Cancel
                    </Button>
                    <Button color="primary" onClick={generateCroppedImage} style={{ zIndex: 1050 }}>
                        Crop & Save
                    </Button>
                </ModalFooter>
            </Modal>
        </React.Fragment >
    );
};

export default connect(null, { setBreadcrumbItems })(CoursesManagement);